module.exports = __webpack_public_path__ + "static/img/ecological_institute_cooperation_zz.fb4a4f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ecological/ecological_institute_cooperation_zz.png
// module id = PFX+
// module chunks = 0